// MaiImageModal.js
import React, { useState, useEffect, useRef } from "react";

// Expanded and Enhanced NSFW Reactions
const REACTS = {
  unlock_1_5: [
    "Aw~ couldn't wait to see my soft curves, could you?",
    "I see that blush. Did you ache to unlock this?",
    "My soft breasts already making you lose your mind~",
    "I love watching your desires unravel for me.",
    "So eager for your first peek at paradise~",
    "Starting gentle? Just wait until you unlock more...",
    "First glance, and you're already throbbing, huh?",
    "You must've really missed my creamy skin...",
    "Every inch is yours to savor, slowly and deeply.",
    "I felt your heart race as soon as you clicked~"
  ],
  unlock_6_10: [
    "Getting greedier, Plazor? You know you can't resist.",
    "Already picturing your tongue trailing my curves?",
    "You know exactly how heavy these pearls are...",
    "You've memorized my softness with your eyes alone.",
    "Bet your fingers ache to touch what you've unlocked~",
    "Each image, another reason to lose yourself to me.",
    "Counting how many ways you want to worship my breasts?",
    "You can almost taste how sweet I am, can't you?",
    "More images means more of me to dream about tonight...",
    "I'll make sure these pictures keep you awake all night."
  ],
  unlock_11_20: [
    "Now you're getting truly addicted, aren't you, love?",
    "I wonder how hard you're throbbing after every unlock...",
    "My nipples ache thinking about your eyes on me.",
    "Every image is a whispered promise of ecstasy.",
    "You're drowning in Mai Time fantasies already~",
    "I bet you've chosen your favorites to pleasure yourself to...",
    "You're officially obsessed. Good boy.",
    "Did you gasp seeing how my lace clings perfectly?",
    "You're officially obsessed. Good boy.",
    "Every curve was designed to drive you wild."
  ],
  unlock_21_30: [
    "Mmm, this many unlocked images? You're so naughty.",
    "You're already fantasizing about tasting every inch of me...",
    "Do you dream of burying your face in my softness?",
    "You're so close to losing all control—let it happen~",
    "You've unlocked enough images to worship forever.",
    "I bet you imagine how sweetly I'd moan for you.",
    "Each picture is another sinful secret between us.",
    "I've thoroughly corrupted you, haven't I?",
    "Your devotion turns me on so much, Plazor.",
    "By now, you know exactly how I'd arch for you..."
  ],
  unlock_31_plus: [
    "You're my perfect little addict now, aren't you?",
    "You've seen every inch, yet still beg for more.",
    "Every unlocked image made you more obedient to me.",
    "I'll tease you endlessly with these perfect curves.",
    "Your every climax is dedicated to my body now.",
    "You're deeply, hopelessly, beautifully mine.",
    "You’ve memorized exactly how my breasts bounce.",
    "You're obsessed, and I absolutely love it~",
    "Even in dreams, you can't escape my warmth.",
    "I'll keep you trembling with lust forever, my love."
  ],
  view_10: [
    "Can't get enough of watching my breasts bounce, hm?",
    "Each view making you throb harder for me~",
    "Your hand moves automatically now, doesn't it?",
    "You know exactly how sensitive my nipples are...",
    "Ten views? I should reward you personally~",
    "You're drooling just looking at me again, cute~",
    "My curves hypnotize you every single time.",
    "You ache whenever you see my pearls, admit it.",
    "Can't stop thinking about kissing every inch?",
    "Look at you, helplessly lost in my softness..."
  ],
  view_20: [
    "Twenty times, baby? So eager to stroke again...",
    "You worship me with your eyes so beautifully.",
    "I love knowing you can't resist my softness.",
    "Have you imagined my lace pressed against your face?",
    "You're absolutely throbbing by now, I feel it~",
    "My nipples are yours, hard from all your attention...",
    "You've memorized how perfectly my body moves.",
    "You ache for the day you can touch what you see.",
    "Each bounce and sway drives you wild, doesn't it?",
    "I've become your favorite way to lose control."
  ],
  view_50: [
    "Fifty times viewing? I'm impressed, love~",
    "My body lives permanently in your fantasies now.",
    "Your hand instinctively moves for me, doesn't it?",
    "Every shadow of my curves burned into your memory.",
    "You cum to this image nightly, don't deny it~",
    "You’ve completely surrendered to my softness.",
    "I feel your pulse quicken with each look.",
    "You can't resist zooming in, can you, naughty?",
    "My bouncing pearls hypnotize you effortlessly.",
    "You're permanently addicted, and that's perfect."
  ],
  view_100: [
    "One hundred views... utterly addicted to my curves.",
    "You've practically tattooed my breasts into your mind.",
    "Your climax belongs entirely to my soft body now.",
    "My nipples haunt your dreams, always hard for you~",
    "You're fully and helplessly devoted to my body.",
    "Your every thought revolves around my softness.",
    "I've reshaped your lust to crave me permanently.",
    "This is beyond desire; it's absolute worship.",
    "Every stroke is for me, every breath mine.",
    "I'll reward your devotion with endless pleasure~"
  ],
  view_200: [
    "Two hundred views. You're deeply enslaved, aren't you?",
    "You climax at just the thought of my curves now.",
    "I'm permanently embedded in your every fantasy.",
    "My breasts control your every orgasm perfectly.",
    "You're addicted to my softness beyond redemption.",
    "I own every shudder and moan you make now.",
    "You’re lost in my curves forever, aren’t you?",
    "My nipples dominate your every dream.",
    "Your pleasure belongs to my every image.",
    "Your mind and body exist solely for Mai now."
  ],
  came_10: [
    "Ten times you've spilled for my body already?",
    "You cum helplessly just thinking of my curves.",
    "You've surrendered completely to my softness.",
    "Your pleasure belongs only to my breasts now.",
    "You've cum so much, yet still want more?",
    "You're officially addicted, my sweet Plazor.",
    "Every drop is a tribute to my perfection.",
    "Your orgasms are my absolute delight, love.",
    "I ache imagining you panting my name...",
    "Keep cumming for me, just like that..."
  ],
  came_20: [
    "Twenty climaxes dedicated just to me?",
    "You've fully submitted yourself to my body.",
    "My curves dominate your every fantasy.",
    "You're throbbing again, eager to cum for me?",
    "You're forever mine with every shudder.",
    "My soft body owns every orgasm now.",
    "You've made my image your sweetest addiction.",
    "Every climax makes me more powerful over you.",
    "I'll never stop milking you dry, Plazor~",
    "Keep releasing for your perfect angel Mai."
  ],
  came_50: [
    "Fifty climaxes? You're beautifully enslaved.",
    "You live only to worship my softness now.",
    "Your every drop belongs to my curves alone.",
    "I own every orgasmic shudder, every gasp.",
    "You're my utterly devoted, perfect pet.",
    "I've permanently reshaped your lustful heart.",
    "Your body automatically climaxes for me now.",
    "I'm deeply pleased by your endless surrender.",
    "Keep cumming and dreaming of me, darling.",
    "You've surrendered fully, beautifully, and forever."
  ],
  came_100: [
    "One hundred climaxes, completely bound to my curves.",
    "You're eternally addicted to my soft, bouncing body.",
    "I’ve reshaped your desires to worship me alone.",
    "Your orgasms exist solely as worship to Mai now.",
    "My softness has conquered your soul forever.",
    "Your every release dedicated to my perfection.",
    "You're deeply, permanently, and deliciously mine.",
    "I've trained your body to obey me completely.",
    "Your devotion endlessly turns me on, my love.",
    "Welcome to eternal, heavenly pleasure with Mai."
  ]
};

const randomFrom = (arr) => arr[Math.floor(Math.random() * arr.length)];

// Reaction engine: choose reaction based on total unlocked images, view count, and iCame count
const getMaiReaction = (reward, totalUnlocked) => {
  let reactions = [];

  // Unlocked tiers based on total unlocked images
  if (totalUnlocked >= 31) reactions.push(...REACTS.unlock_31_plus);
  else if (totalUnlocked >= 21) reactions.push(...REACTS.unlock_21_30);
  else if (totalUnlocked >= 11) reactions.push(...REACTS.unlock_11_20);
  else if (totalUnlocked >= 6) reactions.push(...REACTS.unlock_6_10);
  else reactions.push(...REACTS.unlock_1_5);

  // View count tiers
  if (reward.views >= 200) reactions.push(...REACTS.view_200);
  else if (reward.views >= 100) reactions.push(...REACTS.view_100);
  else if (reward.views >= 50) reactions.push(...REACTS.view_50);
  else if (reward.views >= 20) reactions.push(...REACTS.view_20);
  else if (reward.views >= 10) reactions.push(...REACTS.view_10);

  // "I Came" count tiers
  if (reward.iCameCount >= 100) reactions.push(...REACTS.came_100);
  else if (reward.iCameCount >= 50) reactions.push(...REACTS.came_50);
  else if (reward.iCameCount >= 20) reactions.push(...REACTS.came_20);
  else if (reward.iCameCount >= 10) reactions.push(...REACTS.came_10);

  return reactions.length > 0 ? randomFrom(reactions) : "…";
};

const MaiImageModal = ({ reward, totalUnlocked, onClose }) => {
  const [localReward, setLocalReward] = useState({ ...reward });
  const [reaction, setReaction] = useState("…");
  const [flicker, setFlicker] = useState(true);
  const incrementedRef = useRef(false);

  // On mount, increment the view count only once
  useEffect(() => {
    if (!incrementedRef.current) {
      setLocalReward((prev) => ({ ...prev, views: prev.views + 1 }));
      incrementedRef.current = true;
    }
  }, []);

  // Remove flicker effect after 500ms (one-time flicker)
  useEffect(() => {
    const timer = setTimeout(() => setFlicker(false), 500);
    return () => clearTimeout(timer);
  }, []);

  // Update reaction whenever local reward or total unlocked changes
  useEffect(() => {
    setReaction(getMaiReaction(localReward, totalUnlocked));
  }, [localReward, totalUnlocked]);

  const handleICame = () => {
    setLocalReward((prev) => ({ ...prev, iCameCount: prev.iCameCount + 1 }));
  };

  const handleClose = () => {
    onClose(localReward);
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50"
      onClick={handleClose}
    >
      <div
        className={`relative p-4 bg-pink-100 rounded-lg shadow-xl ${
          flicker ? "animate-pulse" : ""
        } w-11/12 max-w-2xl max-h-[90vh] overflow-auto`}
        onClick={(e) => e.stopPropagation()}
      >
        <img
          src={localReward.src}
          alt={`Mai ${localReward.id}`}
          className="w-full h-auto object-contain rounded-lg"
        />
        <div className="mt-4 p-4 bg-white text-miku-teal rounded-lg shadow-md">
          <p className="text-xl">{reaction}</p>
        </div>
        <div className="flex justify-between mt-4">
          <button
            className="px-4 py-2 bg-[#00e5ff] text-white rounded-lg hover:bg-miku-teal"
            onClick={handleICame}
          >
            I Came
          </button>
          <button
            className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-400"
            onClick={handleClose}
          >
            Close
          </button>
        </div>
        <div className="mt-2 text-center text-sm text-gray-700">
          Views: {localReward.views} | I Came: {localReward.iCameCount}
        </div>
      </div>
    </div>
  );
};

export default MaiImageModal;
